import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_HOST } from 'utils/constants';

const useFetchBrand = () => {
  const { search } = useLocation();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const endpoint = `${API_HOST}/api/shopify/connect${search}`;

  useEffect(() => {
    fetch(endpoint)
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
    //eslint-disable-next-line
  }, []);

  return { data, loading, error };
};

export default useFetchBrand;
